import React from 'react'
import '../style/rulePop.scss'

function RulePop(props) {

  return (
    <div className="popup rule-pop">
      <div className="content">
        <div className="title"></div>
        <ul>
          <li>【活动时间】</li>
          <li>* 即日起至联动上线前一日23:59截止</li>
          <li>【邀请细则】</li>
          <li>* 已预约的血裔，可以通过邀请好友预约，领取<span>额外福利</span>；</li>
          <li>* 成功邀请的条件：被邀请者点击专属链接（即邀请生成的链接）+ 完成预约。若受邀者在被邀请前已完成预约，则当前邀请视为无效</li>
          <li>【福利领取】</li>
          <li>* 领取邀请福利需要等级游戏角色账号，<span>1个预约手机号</span>至多可绑定<span>5个游戏角色</span></li>
          <li>* 角色账号已经绑定，<span>不可解绑或换绑</span>，请务必确认领取账号的信息</li>
          <li>* 达成邀请目标的血裔，可以通过页面直接领取对应福利至游戏中，每阶段奖励限领<span>1</span>次</li>
          <li>* 每阶段奖励领取后将立刻发放至当前已绑定的游戏角色邮箱中，<span>领取后新增绑定的角色将无法获得该阶段奖励</span>，请在领取对应阶段奖励前，完成需要领取的账号绑定。</li>
        </ul>
        <div className="close" onClick={props.toggleRulePop}></div>
      </div>
    </div>
  )
}

export default RulePop;
